import { useQuery } from '@apollo/client';
import { graphql } from '@client/graphql/types';
import { useEffect, useState } from 'react';
import {} from /* remove Analytic_NailAppointment_GetTopServices */ '@client/graphql/types/graphql';

interface TopServiceItem {
  serviceId: string;
  serviceName: string;
  totalSold: number;
  totalRevenue: number;
}

const QUERY = graphql(`
  query analytic_nailAppointment_getTopServices($branchId: ID!, $startTime: DateTime!, $endTime: DateTime!) {
    analytic_nailAppointment_getTopServices(branchId: $branchId, startTime: $startTime, endTime: $endTime) {
      serviceName
      totalSold
      totalRevenue
    }
  }
`);

export default function useGetTopServicesAppointmentReport(branchId: string, startTime: string, endTime: string) {
  const { data, loading, error, refetch } = useQuery(QUERY, {
    variables: { branchId, startTime, endTime },
    skip: !branchId || !startTime || !endTime,
  });

  const [topServicesData, setTopServicesData] = useState<TopServiceItem[] | null>(null);

  useEffect(() => {
    if (data?.analytic_nailAppointment_getTopServices) {
      setTopServicesData(data.analytic_nailAppointment_getTopServices as TopServiceItem[]);
    } else {
      setTopServicesData(null);
    }
  }, [data]);

  return {
    data: topServicesData,
    loading,
    error,
    refetch,
  };
}
